import pt from './pt';
import en from './en';
import es from './es';

export const translations = {
  pt,
  en,
  es
};

export const languages = [
  { code: 'pt', name: 'Português', flag: '🇧🇷' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];
